import React, {useEffect, useState} from 'react';
import {Route, Switch, useParams} from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import List from './';
import {Project} from "~/types";
import {useStoreActions, useStoreState} from "~/store";
import {ROUTES} from "~/app/Router";
import {useHistory} from "react-router";
import MachineDetailsRouter from "~/machines/Details/Router";
import Loader from "~/app/common/Loader";
import { canAccessProjectOffline } from '~/sqlite/lastUsedCache';

export const MACHINES_ROUTES = {
    machines: '/projects/:projectId',
    list: '/projects/:projectId/machines',
    details: '/projects/:projectId/machines/:id'
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
    const history = useHistory();
    const {projectId} = useParams<{ projectId: Project['id'] }>();
    const [fetching, setFetching] = useState<boolean>(true);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const updateLastUsedAction = useStoreActions(actions => actions.projects.updateLastUsed);
    const fetchLastUsedAction = useStoreActions(actions => actions.projects.fetchLastUsed);
    const ProjectFetchAction = useStoreActions(actions => actions.project.fetchProject);
    const inFavorite = useStoreState(state => state.projects.inFavorite(projectId));
    const cacheOpenedProject = useStoreActions(actions => actions.projects.cacheOpenedProject);
    const allowedOffline = canAccessProjectOffline(projectId, inFavorite);

    useEffect(() => {
        if ((netWorkStatus === 0 || allowedOffline) && projectId) {
            if (!+projectId) {
                setFetching(false);
                return;
            }
            ProjectFetchAction(projectId).then(() => {
                setFetching(false);
                if (netWorkStatus === 0) {
                    updateLastUsedAction({projectId: projectId})
                        .then(() => fetchLastUsedAction())
                        .then(() => cacheOpenedProject(projectId));
                }
            }).finally(() => {
                setFetching(false);
            });
        } else {
            history.push(ROUTES.projects);
        }
    }, [ProjectFetchAction, projectId, netWorkStatus, updateLastUsedAction, fetchLastUsedAction, allowedOffline, history, cacheOpenedProject]);

    if (fetching) {
        return <Loader size="32"/>;
    }

    return (
        <RouterSuspense>
            <Switch>
                <Route path={MACHINES_ROUTES.details} component={MachineDetailsRouter}/>
                <Route path={[MACHINES_ROUTES.machines, MACHINES_ROUTES.list]} component={List}/>
            </Switch>
        </RouterSuspense>
    )
};

export default Router;
